var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled, { css } from 'styled-components';
import { media } from '../..';
import { black, white } from '../../colors';
export var StyledNav = styled.nav.withConfig({
  displayName: "NavigationColumnsstyles__StyledNav",
  componentId: "yis2o5-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 7.2rem calc((100% - var(--container-width)) / 2) 0;\n  background-color: ", ";\n\n  display: flex;\n  flex-wrap: wrap;\n\n  & > * {\n    flex-basis: 19rem;\n    flex-shrink: 0;\n    flex-grow: 1;\n\n    ", " {\n      flex-basis: 100%;\n    }\n  }\n"], ["\n  padding: 7.2rem calc((100% - var(--container-width)) / 2) 0;\n  background-color: ", ";\n\n  display: flex;\n  flex-wrap: wrap;\n\n  & > * {\n    flex-basis: 19rem;\n    flex-shrink: 0;\n    flex-grow: 1;\n\n    ", " {\n      flex-basis: 100%;\n    }\n  }\n"])), black(), media.sm);
export var StyledColumn = styled.div.withConfig({
  displayName: "NavigationColumnsstyles__StyledColumn",
  componentId: "yis2o5-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var StyledColumnItem = styled.div.withConfig({
  displayName: "NavigationColumnsstyles__StyledColumnItem",
  componentId: "yis2o5-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 4.8rem;\n"], ["\n  margin-bottom: 4.8rem;\n"])));
export var Title = styled.div.withConfig({
  displayName: "NavigationColumnsstyles__Title",
  componentId: "yis2o5-3"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 1.75rem;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 2rem;\n\n  ", " {\n    font-size: 2rem;\n  }\n"], ["\n  font-size: 1.75rem;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 2rem;\n\n  ", " {\n    font-size: 2rem;\n  }\n"])), media.sm);
export var linkCss = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  margin-bottom: 2rem;\n  text-decoration: none;\n  color: ", ";\n  font-size: 1.75rem;\n  font-weight: 100;\n  line-height: 150%;\n  a&:hover {\n    text-decoration: underline;\n  }\n\n  ", " {\n    font-size: 2rem;\n  }\n"], ["\n  display: block;\n  margin-bottom: 2rem;\n  text-decoration: none;\n  color: ", ";\n  font-size: 1.75rem;\n  font-weight: 100;\n  line-height: 150%;\n  a&:hover {\n    text-decoration: underline;\n  }\n\n  ", " {\n    font-size: 2rem;\n  }\n"])), white(), media.sm);
export var ColumnLink = styled.a.withConfig({
  displayName: "NavigationColumnsstyles__ColumnLink",
  componentId: "yis2o5-4"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), linkCss);
export var ColumnSubLink = styled.a.withConfig({
  displayName: "NavigationColumnsstyles__ColumnSubLink",
  componentId: "yis2o5-5"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  margin-left: 1.6rem;\n"], ["\n  ", "\n  margin-left: 1.6rem;\n"])), linkCss);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;